import footerTemplate from './footer-templates';
import { emptyElement } from '../../utils/utils';
import styles from './footer.css';
import Icon from '../icon/icon.js';
import { setCookie } from '../../fetch-api/lib/auth-token';
import Store from '../../store/store';
import rootReducer from '../../store/reducer/root-reducer';
import {
  savePreferredLanguage,
  doLogout,
  isCCApp
} from '../../../src/api/api.js';

let isDisplayLanguageDialog = false;
let logoutLinkHref = '';
let timerInterval;
const fiveMinutes = 60 * 5;
let isSessionTimeOutDisplayed = false;

const tokenize = (lst) => {
  const re =
    /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return lst.map((item) => {
    if (re.test(item)) {
      return {
        type: 'email',
        value: item
      };
    }
    return {
      type: 'plain',
      value: item
    };
  });
};

const renderEmailLink = (email) =>
  `<a class='${styles.helpEmail}' href='mailto:${email}'>${email}</a>`;

const checkForEmails = (content) => {
  const words = content.split(' ');
  const tokens = tokenize(words);
  return tokens
    .map((item) => {
      switch (item.type) {
        case 'plain':
          return item.value;
        case 'email':
          return renderEmailLink(item.value);
        default:
          return item.value;
      }
    })
    .join(' ');
};

function getHelpContent(content) {
  let listContent = '';
  content.forEach((item) => {
    listContent += `
    <p class=${styles.generatedHeader}>
      ${item.header}
    </p>
    <p class=${styles.generatedBody}> ${checkForEmails(item.body)}</p>
    `;
  });
  return listContent;
}

function getFooterContentHTML(footerVal, currentTarget, node, trans) {
  const controlledElementIds = currentTarget.getAttribute('id');
  const foo = node.querySelector(`#${controlledElementIds}`);
  const parent = foo.parentNode;
  const helper = document.createElement('div');
  let valList = '';
  // eslint-disable-next-line array-callback-return
  footerVal.map((item) => {
    if (item.content) {
      valList += `<div class=${styles.modalWrapper__show} aria-hidden="false" id='modelhelp'>
      <section class='${styles.modalDialog} ${styles.helpDialog}' aria-hidden="false" aria-labelledby="footerModalHeading1" 
      role="dialog" aria-modal="true" id="modalHelpContainer">
        <div class="${styles.header}">
          <h2 class=${styles['change-language-heading']} id="footerModalHeading1">${item.title}</h2>
            <span role="button" class=${styles['modaldialog-close']} tabindex="0" id='closeicon'>
              <i>
              ${Icon('close')}
                </i>
              </span> 
            </div>
            <div class="${styles.body}">
              <div>
                ${getHelpContent(item.content)}
              </div>
              <div class=${styles.field}>
                <button 
                  class="${styles.closeButton} oct-common-header-secondary-background-color" 
                  aria-label="${trans['click-to-close-modal']}" id='closebutton'>
                  ${trans.close}
                </button>
              </div>
            </div>
        </section>
      </div>`;
    }
  });
  helper.innerHTML = valList;
  while (helper.firstChild) {
    parent.insertBefore(helper.firstChild, foo);
  }

  const closeIcon = document.querySelector(`.${styles['modaldialog-close']}`);
  const closeButton = document.querySelector('#closebutton');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      const modelhelp = document.querySelector('#modelhelp');
      requestAnimationFrame(() => {
        modelhelp.parentNode.removeChild(modelhelp);
      });
    });
    closeButton.addEventListener('keydown', (ev) => {
      if (ev.keyCode === 9) {
        requestAnimationFrame(() => {
          closeIcon.focus();
        });
      }
    });
  }

  function removeModelHelp() {
    const modelhelp = document.querySelector('#modelhelp');
    requestAnimationFrame(() => {
      modelhelp.parentNode.removeChild(modelhelp);
    });
  }
  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      removeModelHelp();
    });
    closeIcon.addEventListener('keydown', (ev) => {
      if (ev.keyCode === 13) {
        removeModelHelp();
      }
    });
    requestAnimationFrame(() => {
      closeIcon.focus();
    });
  }
}

function getFooterFormHTML(
  footerVal,
  currentTarget,
  node,
  trans,
  selectedLang,
) {
  const controlledElementIds = currentTarget.getAttribute('id');
  const foo = node.querySelector(`#${controlledElementIds}`);
  const parent = foo.parentNode;
  const helper = document.createElement('div');
  let valList = '';
  // eslint-disable-next-line array-callback-return
  footerVal.map((item) => {
    if (item.form) {
      valList += `<div class=${styles.modalWrapper__show} aria-hidden="false" id='modellang'>
      <section class=${styles.modalDialog} aria-hidden="false" aria-labelledby="lang-persist-modal-header" role="dialog" aria-modal="true">
        <div class="${styles.header}">
          <h2 class=${styles['change-language-heading']} id="footerModalHeading1">${trans['change-language']}</h2>
            <span class=${styles['modaldialog-close']} tabindex="10" id='closeicon'>
            <i>${Icon('close')}</i>
              </span>
            </div>
            <div class="${styles.body}">
              <p class=${styles.generatedHeader}>
                ${trans['would-you-like-preferred-language']}
              </p>
              <div class=${styles.field}>
              <button class=${styles['button-close']} id='closelangbutton'>
                <i>${Icon('close')}</i>
                <span class=${styles.buttonText}>${trans.cancel}</span></button>
              <button class=${styles['button-footer']} id="submitPreferredLang">
              <i>${Icon('check')}</i><span class=${styles.buttonText}>${trans.select}</span></button>
              </div>
            </div>
        </section>
      </div>`;
    }
  });
  helper.innerHTML = valList;
  while (helper.firstChild) {
    parent.insertBefore(helper.firstChild, foo);
  }
  const closeButton = document.querySelector('#closelangbutton');
  const selectButton = document.querySelector('#submitPreferredLang');
  const closeIcon = document.querySelector('#closeicon');

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      const modellang = document.querySelector('#modellang');
      requestAnimationFrame(() => {
        isDisplayLanguageDialog = false;
        modellang.parentNode.removeChild(modellang);
      });
    });
  }

  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      const modellang = document.querySelector('#modellang');
      requestAnimationFrame(() => {
        isDisplayLanguageDialog = false;
        modellang.parentNode.removeChild(modellang);
      });
    });
    closeIcon.addEventListener('keydown', (ev) => {
      const { keyCode } = ev;
      if (keyCode === 9) {
        requestAnimationFrame(() => {
          closeButton.focus();
        });
      }
    });
    requestAnimationFrame(() => {
      closeIcon.focus();
    });
  }

  if (selectButton) {
    selectButton.addEventListener('click', (event) => {
      event.preventDefault();
      savePreferredLanguage(selectedLang)
        .then(() => {})
        .catch((err) => err);

      const modellang = document.querySelector('#modellang');
      requestAnimationFrame(() => {
        isDisplayLanguageDialog = false;
        modellang.parentNode.removeChild(modellang);
      });
    });
    selectButton.addEventListener('keydown', (ev) => {
      const { keyCode } = ev;
      if (keyCode === 9) {
        requestAnimationFrame(() => {
          closeIcon.focus();
        });
      }
    });
  }
}

function getFooterLinkHTML(footerVal, selectedLang, trans) {
  let valList = '';
  // eslint-disable-next-line array-callback-return
  footerVal.map((item) => {
    valList += `<li class=${styles.footer__menu__item}>`;
    if (item.link) {
      valList += `<a href=${item.link} target=${item.target} class=${styles.footerLink}>${item.title}</a>`;
    }
    if (item.content) {
      valList += `<div class=${styles.footer__menu__item}><button class=${styles.footerLink} id='helpcontent'>${item.title}</button>`;
      valList += '</div>';
    }
    if (item.form) {
      valList += `<div><form class=${styles['footer-form']}>
      <span class="footerSelect">
      <select class=${styles.selectList} aria-selected="${selectedLang}" aria-label="${trans['select-language']}" id='selectlang'>`;
      // eslint-disable-next-line prefer-destructuring
      const options = item.form.input.language.options;
      // eslint-disable-next-line array-callback-return
      options.map((option) => {
        valList += `<option value="${option.value}" aria-label="${option.text}" ${selectedLang === option.value ? 'selected' : ''} >
        ${option.text}
      </option>`;
      });
      valList += '</select></span></form></div>';
    }
    valList += '</li>';
  });
  return valList;
}

function startTimer(duration, display) {
  let timer = duration;
  let minutes = 0;
  let seconds = 0;
  const displayHtml = display;
  timerInterval = setInterval(() => {
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    displayHtml.textContent = `${minutes}:${seconds}`;
    timer -= 1;
    if (timer < 0) {
      clearInterval(timerInterval);
      doLogout(logoutLinkHref);
    }
  }, 1000);
}

function getFooterSessionHtml(node, logoutLink, handleSession, store) {
  const { state: { translations: trans = {} } = {} } = store;
  const parent = node;
  const helper = document.createElement('div');
  isSessionTimeOutDisplayed = true;
  const valList = `<div class='${styles.modalWrapper__show} ${styles.modal__session}' aria-hidden="false" id='modelSession'>
      <section class='${styles.modalDialog}' aria-hidden="false" aria-labelledby="footerModalHeading1" 
      role="dialog" aria-modal="true" id="modalSessionContainer">
        <div class="${styles.header}">
          <h2 class=${styles['change-language-heading']} id="footerModalHeading1">${trans['session-timeout-warning']}</h2>
        </div>
          <div class="${styles.body}">
            <div class="${styles.sessionInfo}">
              ${trans['about-to-expire']}
            </div>
            <div class="${styles.sessionTime}">
              ${trans['time-left']} <span id='time-left'>05:00</span>
            </div>
            <div class=${styles.field}>
              <button class='${styles['button-footer']} ${styles['button-footer-ok']}' id="submitSessionExtend">
              <i>${Icon('check')}</i><span class=${styles.buttonText}>${trans.ok}</span></button>
            </div>
          </div>
        </section>
      </div>`;

  helper.innerHTML = valList;
  while (helper.firstChild) {
    parent.appendChild(helper.firstChild);
  }

  const confirmBtn = document.querySelector('#submitSessionExtend');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      isSessionTimeOutDisplayed = false;
      handleSession(store.dispatch);
    });
  }
  const {
    location: { origin = '' }
  } = window;
  logoutLinkHref = isCCApp() ? `${origin}/logout` : logoutLink;
  const display = document.querySelector('#time-left');
  startTimer(fiveMinutes, display);
}

function getCurrentYear() {
  const dt = new Date();
  return dt.getFullYear();
}

class Footer {
  defaultProps = {
    translations: {},
    currentSelectedLanguage: 'en_US',
    logoutLink: '',
    isEclientLink: false
  };
  constructor(
    selector,
    {
      desktopSidebarIsToggleable = false, callback, handleSession, storeObj
    },
  ) {
    const node = document.querySelector(selector);
    this.props = { ...this.defaultProps };
    this.store = new Store(rootReducer);
    this.desktopSidebarIsToggleable = desktopSidebarIsToggleable;
    this.translations = this.props.translations;
    this.currentSelectedLanguage = this.props.currentSelectedLanguage;
    this.logoutLink = this.props.logoutLink;
    this.isEclientLink = this.props.isEclientLink;
    this.callback = callback;
    this.handleSession = handleSession;
    this.appStoreObj = storeObj;
    if (node) {
      this.node = node;
    } else {
      console.error(
        `element, ${selector}, should exist for Common Footer to work properly`,
      );
    }
    this.toggleSidebar = () => {};
  }

  set isEclientLink(x) {
    this.props.isEclientLink = x;
  }

  get isEclientLink() {
    return this.props.isEclientLink;
  }

  set footerLinks(footerData) {
    if (footerData && footerData.length > 0) {
      const trans = this.translations;
      if (this.isEclientLink) {
        document.getElementById('copyright').innerHTML =
          `© ${getCurrentYear()} O.C.Tanner Company. All rights reserved.`;
      } else {
        document.getElementById('copyright').innerHTML = trans.copyright;
      }
      const foo = this.node.querySelector('#copyright');
      const parent = foo.parentNode;
      const helper = document.createElement('div');
      let valList = `<nav> <ul class="${styles['list-unstyled']} ${this.isEclientLink ? styles.eclient_app_footer : ''}">`;
      valList += getFooterLinkHTML(
        footerData,
        this.currentSelectedLanguage,
        trans,
      );
      valList += '</ul></nav>';
      helper.innerHTML = valList;
      while (helper.firstChild) {
        parent.insertBefore(helper.firstChild, foo);
      }
      const helpButton = document.querySelector('#helpcontent');
      if (helpButton) {
        helpButton.addEventListener('click', (evt) => {
          const { currentTarget } = evt;
          requestAnimationFrame(() => {
            getFooterContentHTML(footerData, currentTarget, this.node, trans);
          });
        });
      }
      const selectlang = document.querySelector('#selectlang');
      if (selectlang) {
        selectlang.addEventListener('change', (evt) => {
          const { currentTarget } = evt;
          const key = 'language';
          const value = selectlang.value.replace('_', '-');
          setCookie(key, value);
          this.callback({}, {}, value);
          const { location = {}, history = {} } = window;
          if (location && history) {
            const { href = '', pathname = '' } = location;
            if (href.includes('?')) {
              history.replaceState({}, document.title, pathname);
            }
          }
          requestAnimationFrame(() => {
            isDisplayLanguageDialog = true;
            getFooterFormHTML(
              footerData,
              currentTarget,
              this.node,
              trans,
              this.currentSelectedLanguage,
            );
          });
        });
      }
      if (isDisplayLanguageDialog) {
        requestAnimationFrame(() => {
          const currentTarget = selectlang;
          getFooterFormHTML(
            footerData,
            currentTarget,
            this.node,
            trans,
            this.currentSelectedLanguage,
          );
        });
      }
    }
  }

  set translations(trans) {
    this.props.translations = trans;
  }

  get translations() {
    return this.props.translations;
  }

  set currentSelectedLanguage(trans) {
    this.props.currentSelectedLanguage = trans;
  }

  get currentSelectedLanguage() {
    return this.props.currentSelectedLanguage;
  }

  set sessionExtendDialog(obj) {
    if (obj.isDisplaySession || isSessionTimeOutDisplayed) {
      getFooterSessionHtml(
        this.node,
        this.logoutLink,
        this.handleSession,
        this.appStoreObj,
      );
    }
    if (!isSessionTimeOutDisplayed && !obj.isDisplaySession) {
      const modelSession = document.querySelector('#modelSession');
      if (modelSession) {
        requestAnimationFrame(() => {
          modelSession.parentNode.removeChild(modelSession);
        });
        clearInterval(timerInterval);
      }
    }
  }

  set logoutLink(link) {
    this.props.logoutLink = link;
  }

  get logoutLink() {
    return this.props.logoutLink;
  }

  render = () => {
    emptyElement(this.node);
    const frag = document.createRange().createContextualFragment(
      footerTemplate({
        desktopSidebarIsToggleable: this.desktopSidebarIsToggleable
      }),
    );
    this.node.appendChild(frag);
  };
}

export default Footer;
